<template>
    <div class="container_chooseat_seat">
        <div class="chooseat_seat">
            <span :class="{langKh: addFontKhmer}">{{$t('message.chooseSeat')}}</span>
        </div>
        <div style="position: fixed;top: 43px;width: 100%;background: #FFF;">
            <table style="width: 100%;padding-left: 15px;">
                <tr>
                    <td><div style="border: 1px solid;height: 25px;border-radius: 8px;width: 100px;" class="available"></div></td>
                    <td><div style="border: 1px solid #26267c;border: 1px solid #26267c;height: 25px;border-radius: 8px;background: #26267c;width: 100px;" class="selected"></div></td>
                    <td><div style="border: 1px solid red;height: 25px;border-radius: 8px;background: red;width: 100px;" class="not_available"></div></td>
                </tr>
                <tr>
                    <td><div style="text-align: center;width: 100px;margin-top: 4px;font-weight: 500;color: gray;" :class="{langKh: addFontKhmer}">{{$t('message.free')}}</div></td>
                    <td><div style="text-align: center;width: 100px;margin-top: 4px;font-weight: 500;color: gray;" :class="{langKh: addFontKhmer}">{{$t('message.selected')}}</div></td>
                    <td><div style="text-align: center;width: 100px;margin-top: 4px;font-weight: 500;color: gray;" :class="{langKh: addFontKhmer}">{{$t('message.noAvailable')}}</div></td>
                </tr>
            </table>
        </div>
        
        <!-- loading -->
        <div v-if="loading" class="data-loading" style="text-align: center;position: fixed;width: 100%;height: 80%;display: flex;justify-content: center;align-items: center;">
          <van-loading size="35" color="#de5d0a" />
        </div>
        <!-- Get Seat -->
         <div>
            <!-- Get Seat -->
            <table style="width: 100%;margin-top: 120px;margin-bottom: 80px;padding-right: 10px;padding-left: 10px;">
                <tr v-for="(colunm ,index) in colunms" :key="index">
                    <td v-for="(row, index1) in arraydata[index]['col'].length" :key="index1" style="text-align: center;width: 40px;">
                        <div v-if="arraydata[index]['col'][index1]['label'] != ''" style="margin: 0px;">
                            <div v-if="!(arraydata[index]['col'][index1]['label'] == 'Down Stair' || arraydata[index]['col'][index1]['label'] == 'Up Stair' || arraydata[index]['col'][index1]['label'] == 'Capitain' || arraydata[index]['col'][index1]['label'] == 'Toilet' || arraydata[index]['col'][index1]['label'] == 'Hostess' || arraydata[index]['col'][index1]['label'] == 'Door')">
                                <div v-if="!(getUnva(arraydata[index]['col'][index1]['value']))">

                                    <img v-if="!selectedSeat || !(getSeat(arraydata[index]['col'][index1]['value']))" @click="addClick(arraydata[index]['col'][index1]['value'],arraydata[index]['col'][index1]['label'])" :src="require('@/assets/available.svg')" style="width:40px" alt="">
                                    
                                </div>
                            
                            </div>
                            <img v-if="getUnva(arraydata[index]['col'][index1]['value'])" :src="require('@/assets/not_available.svg')" style="width:40px" alt="">

                            <img v-if="selectedSeat && getSeat(arraydata[index]['col'][index1]['value'])"  @click="deleteSeat(arraydata[index]['col'][index1]['value'],arraydata[index]['col'][index1]['label'])" :src="require('@/assets/selected.svg')" style="width:40px" alt="">
                        </div>

                        <img v-if="arraydata[index]['col'][index1]['label'] == ''" :src="require('@/assets/invisible.svg')" style="width:20px" alt="">
                        
                        <p v-if="!(arraydata[index]['col'][index1]['label'] == 'Hostess' || arraydata[index]['col'][index1]['label'] == 'Capitain')" style="font-size: 14px;font-weight: bold;margin-top: -3px;margin-bottom: 0;">{{ arraydata[index]['col'][index1]['label'] }}</p>
                        <img v-if="arraydata[index]['col'][index1]['label'] == 'Capitain'" :src="require('@/assets/captain.png')" style="width:30px;" alt="">
                        <img v-if="arraydata[index]['col'][index1]['label'] == 'Hostess'" :src="require('@/assets/hostess.png')" style="width:30px;" alt="">

                    </td>
                </tr>
            </table>
            <!-- End Get Seat -->
        
            <div class="btn-then" @click="getBtnthen()">
                <button :class="{langKh: addFontKhmer}">{{$t('message.next')}}</button>
            </div>
        </div>
         <!-- alert Dialog -->
        <div v-if="showSeat">
            <div class="van-overlay" style="z-index: 2001;"></div>
            <div class="van-popup van-popup--center van-dialog van-dialog--round-button" role="dialog" tabindex="0" aria-labelledby="Information" style="z-index:2002;">
                <div class="van-dialog__header" :class="{langKh: addFontKhmer}">{{$t('message.warning')}}</div>
                <div class="van-dialog__content">
                    <div class="van-dialog__message van-dialog__message--has-title" :class="{langKh: addFontKhmer}">{{$t('message.descriptionSeatBack')}} {{seatlength.length}}</div>
                </div>
                <div class="van-action-bar van-safe-area-bottom van-dialog__footer">
                    <button type="button" @click="closedSeat" class="van-button van-button--danger van-button--large van-action-bar-button van-action-bar-button--danger van-action-bar-button--last van-action-bar-button--first van-dialog__confirm">
                        <div class="van-button__content">
                            <span class="van-button__text" :class="{langKh: addFontKhmer}">{{$t('message.ok')}}</span>
                        </div>
                    </button>
                </div>
            </div>
        </div>
    </div>
    <div v-if="seatBErrorIn">
        <div class="van-overlay" style="z-index: 2001;"></div>
        <div class="van-popup van-popup--center van-dialog van-dialog--round-button" role="dialog" tabindex="0" aria-labelledby="Information" style="z-index:2002;">
            <div class="van-dialog__header" :class="{langKh: addFontKhmer}">{{$t('message.information')}}</div>
            <div class="van-dialog__content">
                <div class="van-dialog__message van-dialog__message--has-title" :class="{langKh: addFontKhmer}">{{$t('message.msgInternet')}}</div>
            </div>
            <div class="van-action-bar van-safe-area-bottom van-dialog__footer">
                <button type="button" @click="closedSeatError()" class="van-button van-button--danger van-button--large van-action-bar-button van-action-bar-button--danger van-action-bar-button--last van-action-bar-button--first van-dialog__confirm">
                    <div class="van-button__content">
                        <span class="van-button__text" :class="{langKh: addFontKhmer}">{{$t('message.ok')}}</span>
                    </div>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import {Loading} from "vant";
import qs from 'qs';
import axios from "axios";
export default {
    components: {
        [Loading.name]: Loading
    },
    data() {
        return {
            url: localStorage.getItem("url"),
            bearer: localStorage.getItem("bearer"),
            addFontKhmer: false,
            showSeat: false,
            loading: true,
            info: null,
            errored: false,
            rows: 0,
            colunms: 0,
            arraydata: [],
            unavailables: [],
            seats: [],
            seatname: [],
            selectedSeat: false,
            unava: false,
            seatlength: [],
            seatBErrorIn: false,
        }
    },
    methods: {
        closedSeatError() {
            this.seatBErrorIn = false;
            this.getDateLayout();
        },
        getBtnthen() {     
            if(this.seatlength.length == this.seats.length){
                localStorage.setItem('seatback', this.seats);
                localStorage.setItem('seatlabelback', this.seatname);
                this.$router.push("/passenger-info");
            }else{
                this.showSeat = true;
            }
        },
        closedSeat() {
            this.showSeat = false;
        },
        addClick(value, label) {
            if(this.seats.length >= this.seatlength.length) {
                this.showSeat = true;
            }else{
                this.selectedSeat = true;
                this.seats.push(value);
                this.seatname.push(label);
            } 
        },
        getUnva(item) {
            let check = true; 
            for(let j = 0; j < this.unavailables.length; j++) {

                if(item == this.unavailables[j]) {
                    check = true
                    break;
                }else{
                    check = false;
                }
            }
            if(this.unavailables.length == 0){
                return false;
            }
            return check;
        },
        getSeat(item) {
            let check = true; 

            for(let j = 0; j < this.seats.length; j++) {
        
                if(item == this.seats[j]) {
                    check = true
                    break;
                }else{
                    check = false;
                }
            }

            return check;
        },
        deleteSeat(value, label) {

            if(this.seats.length == 1) {
                this.selectedSeat = false;
            }

            for(let j = 0; j < this.seats.length; j++) {
                if(this.seats[j] == value) { this.seats.splice(j, 1); }
            }

            for(let j = 0; j < this.seatname.length; j++) {
                if(this.seatname[j] == label) { 
                    this.seatname.splice(j, 1); 
                }
            }

            if(this.seats.length == 0){ this.selectedSeat = false; }

            if(this.seatname.length == 0){ this.selectedSeat = false; }

        },
        
        // Get Data From Api Layout
        async getDateLayout() {
        
            const data = {'date': localStorage.getItem('dateFrom'),'journey': localStorage.getItem('journeyidback')};
            const url = this.url + `seat/layout`;

            let config = {
                method: "POST",
                headers: {
                    "Authorization": this.bearer,
                    "Content-Type":"application/x-www-form-urlencoded; charset=UTF-8",
                    "accept": "*/*",
                },
                data: qs.stringify(data),
                url
            };

            axios(config).then(response => {
                if(response.status == 200){
                    if(response.data.header.result == true && response.data.header.statusCode == 200) {
                        this.loading = false;
                        this.info = response.data.body;
                        let layout = JSON.parse(this.info[0]['layout']);
                            
                        this.arraydata = JSON.parse(this.info[0]['layout']);
                        this.colunms = layout.length;

                            let colspan = [];
                            for(let i = 0; i < this.arraydata[0]['col'].length; i++) {
                                colspan.push(this.arraydata[0]['col'][i]);
                                if(this.arraydata[0]['col'][i]['attr']['colspan'] != ''){   
                                    for(let j = 0; j < this.arraydata[0]['col'][i]['attr']['colspan'] - 1; j++) {
                                        colspan.push({
                                            attr: {
                                                colspan: '',
                                                rowspan: '',
                                            },
                                            value: '',
                                            label: ''
                                        });
                                    }
                                }
                            }
                            this.arraydata.splice(0, 1, {col: colspan, row: ''})
                            this.rows = layout[0]['col'].length;
                            this.getDataUnavailable();
                    }else{
                        this.errored = true
                    }
                }
            }).catch(error => {
                this.seatBErrorIn = true;
                console.log(error);
            })
        },

        // Get Data From Api Unavailable
        async getDataUnavailable() {
            const data = {'date': localStorage.getItem('dateFrom'),'journey': localStorage.getItem('journeyid')};
            const url = this.url +`seat/unavailable`;

            let config = {
                method: "POST",
                headers: {
                    "Authorization": this.bearer,
                    "Content-Type":"application/x-www-form-urlencoded; charset=UTF-8",
                    "accept": "*/*",
                },
                data: qs.stringify(data),
                url
            };

            axios(config).then(response => {
                if(response.status == 200){
                    if(response.data.header.result == true && response.data.header.statusCode == 200) {
                        let data = response.data.body;
                        let size = response.data.body.length;
                        
                        if(response.data.body != 0) {
                            for(let i = 0; i < size; i++) {
                                this.unavailables.push(data[i]['seatNumber']);
                            }
                        }

                        if(localStorage.getItem('seatback') != null) {

                            let arrayNew = localStorage.getItem('seatback');
                            let seatArray = arrayNew.split(",");

                            for(let i = 0 ; i < seatArray.length; i++) {

                                if(seatArray[i] != ',') {
                                    this.seats.push(seatArray[i]);
                                }
                            
                            } 
                            this.selectedSeat = true;
                        }

                        if(localStorage.getItem('seatlabelback') != null) {

                            let arrayNew = localStorage.getItem('seatlabelback');
                            let seatArray = arrayNew.split(",");

                            for(let i = 0 ; i < seatArray.length; i++) {

                                if(seatArray[i] != ',') {
                                    this.seatname.push(seatArray[i]);
                                }
                            
                            } 
                            this.selectedSeat = true;
                        }

                    }else{
                        this.errored = true
                    }

                }
            }).catch(error => {console.log(error);})
        },
    },
    created() {
        this.$bridge.callHandler("setBarTitle", { title: "Select Return Seat", bgColor: "#de5d0a",color: "#ffffff"});
        if(this.$i18n.locale == "en") {
            this.addFontKhmer = false;
        }else {
            this.addFontKhmer = true;
        }
        if(localStorage.getItem('seat') != null) {

            let arrayNew = localStorage.getItem('seat');
                
            let seatArray = arrayNew.split(",");

                for(let i = 0 ; i < seatArray.length; i++) {

                    if(seatArray[i] != ',') {
                        this.seatlength.push(seatArray[i]);
                    }
                
                } 
        }
        setTimeout(() => {
            this.getDateLayout();
        }, 1000);
    }
}
</script>

<style>
    .container_chooseat_seat {
        width: 100%;
    }
    .container_chooseat_seat .chooseat_seat {
        position: fixed;
        width: 100%;
        top: 0;
        padding: 10px 10px 10px 15px;
        font-size: 18px;
        font-weight: 500;
        background: #FFF;
    }
    .btn-then {
        position: fixed;
        width: 100%;
        height: 70px;
        bottom: 0;
        background: #FFF;
        padding: 0px 20px 0px 20px;
        box-shadow: rgb(99 99 99 / 20%) 0px 2px 8px 0px;
    }
    .btn-then button {
        border: 1px solid;
        background: #de5d0a;
        padding: 10px;
        width: 100%;
        color: #fff;
        position: relative;
        top: 15px;
        border-radius: 8px;
    }
</style>